import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthenticationStorageService } from '@core/storage/jwt-storage-service';
import { ToastService } from '@core/services/toast.service';
import { AuthenticationService } from '@core/services/authentication.service';


@Injectable()
export class PermGuard implements CanActivate, CanActivateChild {
    constructor(private _router: Router,
        private _authStorageService: AuthenticationStorageService,
        private _toastService: ToastService,
        private _authService: AuthenticationService) { }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return true;
    }


    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const requiredPermission = route.data['permissions'] as Array<number>;
        const canActivate = this._authStorageService.hasAnyPermission(requiredPermission);
        if (canActivate === false) {
            this._toastService.error('You do not have permission to view this.');
        }
        return canActivate;
    }
}
